export default "__VITE_ASSET__vMTEHacK__"